import { render, staticRenderFns } from "./ModalSelectSeminarGoal.vue?vue&type=template&id=19888fa3&scoped=true&lang=pug&"
import script from "./ModalSelectSeminarGoal.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectSeminarGoal.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSelectSeminarGoal.vue?vue&type=style&index=0&id=19888fa3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19888fa3",
  null
  
)

export default component.exports